import {
    COMMON
} from '../constants/funcUrl'

const commonMutation = {
    [COMMON.COMMONDEPTS](state, data) {
        state.depts = data;
    },
    [COMMON.COMMONZDDEPTS](state, data) {
        state.zdDepts = data;
    },
    [COMMON.COMMONTRANSFERDEPTS](state, data) {
        state.transferDepts = data;
    },
    [COMMON.COMMONCASEREASONS](state, data) {
        state.caseReasons = data;
    },
    [COMMON.COMMONDOCUSETYPES](state, data) {
        state.docUseTypes = data;
    },

    [COMMON.USERDEPTUSERS](state, data) {
        state.deptUsers = data;
    },

    [COMMON.DOCCATALOGDOCCATALOGS](state, data) {
        state.docCatalogs = data;
    },
    [COMMON.DOCCATALOGALLDOCCATALOGS](state, data) {
        state.allDocCatalogs = data;
    },

    [COMMON.DOCINRECORDS](state, data) {
        state.docInRecords = data;
    },
    [COMMON.DOCINCODESEQUENCE](state, data) {
        state.docInCodeSequence = data;
    },

    [COMMON.DOCOUTRECORDS](state, data) {
        state.docOutRecords = data;
    },
    [COMMON.DOCOUTDOCCATALOGS](state, data) {
        state.docOutDocCatalogs = data;
    },

    [COMMON.DOCRECEIVERECORDS](state, data) {
        state.docReceiveRecords = data;
    },
    [COMMON.DOCRECEIVEDOCCATALOGS](state, data) {
        state.docReceiveDocCatalogs = data;
    },

    [COMMON.DOCDOCS](state, data) {
        state.docs = data;
    },
    [COMMON.DOCFEEDBACKS](state, data) {
        state.docFeedbacks = data;
    },

    [COMMON.DOCSTOCKSTATS](state, data) {
        state.docStockStats = data;
    },
    [COMMON.DOCUSESTATS](state, data) {
        state.docUseStats = data;
    },

    [COMMON.CASECASES](state, data) {
        state.cases = data;
    },
    [COMMON.CASEMYCASES](state, data) {
        state.myCases = data;
    },
    [COMMON.CASERECEIVECASES](state, data) {
        state.receiveCases = data;
    },
    [COMMON.CASEDETAILS](state, data) {
        state.caseDetails = data;
    }
}

export default commonMutation;



// WEBPACK FOOTER //
// ./src/store/sczdzf/mutations/commonMutation.js